var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.725,
    height: 29.725,
    viewBox: "0 0 29.725 29.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7183",
    "data-name": "Group 7183",
    transform: "translate(-811.138 -463.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7177",
    "data-name": "Group 7177",
    transform: "translate(522 179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7175",
    "data-name": "Group 7175",
    transform: "translate(-20 71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 13.843,
    cy: 13.843,
    r: 13.843,
    transform: "translate(310.139 214.174) rotate(-0.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_291_-_Outline",
    "data-name": "Ellipse 291 - Outline",
    d: "M13.843-1a14.843,14.843,0,0,1,10.5,25.339A14.843,14.843,0,0,1,3.348,3.348,14.746,14.746,0,0,1,13.843-1Zm0,27.687A12.843,12.843,0,1,0,1,13.843,12.858,12.858,0,0,0,13.843,26.687Z",
    transform: "translate(310.139 214.174) rotate(-0.073)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-6256.12,34.843h-.019a13.752,13.752,0,0,1-9.782-4.049,13.758,13.758,0,0,1-4.062-9.778,13.749,13.749,0,0,1,4.042-9.793,13.752,13.752,0,0,1,9.784-4.067h.02c.164,0,.332,0,.5.009V34.834C-6255.811,34.84-6255.973,34.843-6256.12,34.843Z",
    transform: "translate(7082.139 457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2_-_Outline",
    "data-name": "Subtraction 2 - Outline",
    d: "M-6256.119,35.843h-.02a14.745,14.745,0,0,1-10.489-4.341,14.752,14.752,0,0,1-4.355-10.484,14.743,14.743,0,0,1,4.334-10.5,14.746,14.746,0,0,1,10.491-4.361h.021c.176,0,.355,0,.534.009l.965.034V35.8l-.965.034C-6255.777,35.84-6255.951,35.843-6256.119,35.843Zm-.52-27.677a12.751,12.751,0,0,0-8.594,3.764,12.758,12.758,0,0,0-3.75,9.086,12.764,12.764,0,0,0,3.769,9.072,12.752,12.752,0,0,0,8.576,3.747Z",
    transform: "translate(7082.139 457)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.5debd95b9cdb1d7bf667fdcc0c9f5e7a.svg";
export { ForwardRef as ReactComponent };